export default "__VITE_ASSET__DvSBsTiT__"